import React from "react";
import useFunction from "../../hooks/useFunction";
import yesIcon from "../../assets/icons/yes.svg"
import noIcon from "../../assets/icons/no.svg"
import Button from "../Button/Button";
// import './Verified-style.scss'

const VerifyIban = (props) => {

  const {
    label,
    text,
    value,
    hasError,
    error,
    validateButtonOnClick,
    validateButtonLabel,
    formData,
    name,
    save,
    removeOtherFields,
  } = props

  const {dateTime} = useFunction()

  const removeValidation = () => {
    formData.model[name] = 'remove-validation'
    if (removeOtherFields) {
      removeOtherFields.map((fieldKey) => {
        formData.model[fieldKey] = ''
        return fieldKey
      })
    }
    save()
  }

  const isValid = () => {
    return value && value !== 'remove-validation'
  }

  return (
    <div className="form-component-verified">
      <label>{label} validatiestatus:<img className="status-icon" src={isValid() ? yesIcon : noIcon} alt="status"/>
        {text && text !== '' &&
          <p className="text-small">{text}</p>
        }
        {hasError && <span className="error"> - {error}</span>}
        <br/>
      </label>
      {isValid() ?
        <div>
          <div className="small-label">Gevalideerd op: {dateTime(value)}</div>
          <br/>
          <Button
            onClick={() => removeValidation()}
            color="red-ghost"
            size="s"
            label="IBAN Validatie verwijderen"
          />
          <br/>
          <br/>
        </div>
        :
        <div>
          <div className="small-label">Niet gevalideerd</div>
          <br/>

          <Button
            onClick={() => (validateButtonOnClick) ? validateButtonOnClick() : null}
            color="green"
            size="s"
            debounce={3000}
            label={validateButtonLabel}
          />
        </div>
      }


    </div>
  )


}


export default VerifyIban
